import {PaymentProviderType} from "../order/models";
import { LocalizedString } from "../general/models";

type Currency = "USD" | "RUB";

export interface PriceInCurrency {
    currencyId: Currency;
    price: number;
}

export enum DeliveryType {
    toTable = 'ToRestaurantTable',
    toAddress = 'ToAddress',
    takeaway = 'TakeAway',
    takeawayToTime = 'TakeAwayToTime',
    toVehicle = 'ToVehicle',
    insideTheRestaurant = 'InsideTheRestaurant'
}

export interface DeliveryToTableDetails {
    type: DeliveryType.toTable,
    tableId: number,
    seatId: string | null
}
export interface DeliveryToAddressDetails {
    type: DeliveryType.toAddress,
    address: string;
    streetType: string | null;
    street: string | null;
    houseType: string | null;
    house: string | null;
    buildingType: string | null;
    building: string | null;
    comment: string | null;
    coordinates: Coordinates | null;
    flat: number | null;
    floor: number | null;
    name: string | null;
    phoneNumber: string;
    porch: string | null;
}
export interface DeliveryTakeAwayDetails {
    type: DeliveryType.takeaway,
    phoneNumber: string;
    name: string | null;
}

export interface DeliveryDetailsTakeAwayToTime {
    type: DeliveryType.takeawayToTime,
    name: string | null;
    phoneNumber: string;
    toHour: number | null;
    toMinute: number | null;
    date: Date | null;
}

export interface DeliveryToVehicleDetails {
    type: DeliveryType.toVehicle,
    phoneNumber: string;
    vehicleBrandName: string,
    vehicleColor: string,
    vehiclePlateNumber: string,
}
export interface DeliveryInsideTheRestaurantDetails {
    type: DeliveryType.insideTheRestaurant,
}
export type DeliveryDetails = DeliveryToTableDetails | DeliveryToAddressDetails |
    DeliveryTakeAwayDetails | DeliveryDetailsTakeAwayToTime | DeliveryToVehicleDetails | DeliveryInsideTheRestaurantDetails;

export interface Coordinates {
    latitude: number;
    longitude: number;
}
export enum DeliveryConditionType{
    fixedPrice = 'FixedPrice',
    dynamicPrice = 'DynamicPrice',
    zonePrice = "ZonePrice"
}

export interface IDeliveryConditionsFixedPrice{
    type: DeliveryConditionType.fixedPrice,
    fixedDeliveryPrice: PriceInCurrency,
    freeDeliveryMinimalOrderPrice: PriceInCurrency
}

export interface IDeliveryConditionsDynamicPrice{
    type: DeliveryConditionType.dynamicPrice,
}

export interface IDeliveryConditionsZonePrice{
    type: DeliveryConditionType.zonePrice,
}


export interface Coordinates {
    latitude: number;
    longitude: number;
}

export type DeliveryConditions = IDeliveryConditionsDynamicPrice | IDeliveryConditionsFixedPrice | IDeliveryConditionsZonePrice;


interface MenuPhotos {
    backgroundPhotoUrl: string | null;
    logoPhotoUrl: string | null;
}

export interface IOfflinePaymentSettings{
    isEnabled: boolean,
    type: PaymentProviderType.offline
}

export interface ICloudPaymentsPaymentSettings{
    isEnabled: boolean,
    type: PaymentProviderType.cloudpayments
}
export interface ISBPTochkaPaymentSettings{
    isEnabled: boolean,
    type: PaymentProviderType.sbpTochka
}

export interface ICompanyInvoiceSettings{
    isEnabled: boolean,
    type: PaymentProviderType.companyInvoice,
}

export interface IToBankCardPaymentSettings{
    isEnabled: boolean,
    type: PaymentProviderType.toBankCard,
    requisites: string,
    title: LocalizedString,
    description: LocalizedString,
    buttonTitle: LocalizedString,
    buttonUrl: string
}


export interface AddressDetails {
    title: { [key: string]: string } | null;
}

export interface ContactDetails {
    instagram: string | null;
    phoneNumber: string | null;
    telegram: string | null;
    websiteUrl: string | null;
    whatsApp: string | null;
}

export interface WorkingSchedule {
    friday: WorkingScheduleDay;
    monday: WorkingScheduleDay;
    saturday: WorkingScheduleDay;
    sunday: WorkingScheduleDay;
    thursday: WorkingScheduleDay;
    timezoneInMinutes: number;
    tuesday: WorkingScheduleDay;
    wednesday: WorkingScheduleDay;
}

export interface WorkingScheduleDay {
    isDayOff: boolean;
    slots: WorkingScheduleDaySlot[];
}
export interface WorkingScheduleDaySlot {
    fromHour: number;
    fromMinute: number;
    toHour: number;
    toMinute: number;
}


export enum MenuItemsPhotosModes{
    defaultWithPhotos = "defaultWithPhotos",
    defaultNoPhotos = "defaultNoPhotos",
    verticalWithPhotos = "verticalWithPhotos",
}


export enum MenuType {
    regular = "Regular",
    none = 'None'
}

export enum StaffCallKind {
    waiter = 'Waiter',
    bill = 'Bill',
    hookah = 'Hookah',
    administrator = 'Administrator'
}


export interface ThemeSettings {
    storefrontPhotosMode: MenuItemsPhotosModes;
    buttonsBackgroundColor: string | null;
    categoriesBackgroundColor: string | null;
    // Подпись к зачёркнутой цене. null — заведение её не задало либо кабинету
    // не включена фича (бэк вырезает поле в публичной выдаче меню).
    oldPriceLabel: LocalizedString | null;
}
export interface MenuData {
    addressDetails: AddressDetails;
    contactDetails: ContactDetails;
    workingSchedule: WorkingSchedule;
    name: { [key: string]: string };
    description: { [key: string]: string };
    isPromoCodesEnabled: boolean;
    staffCalls: StaffCallKind[];
    isMenuEnabled: boolean;
    deliverySettings:{
        [DeliveryType.toTable]:{
            isEnabled: boolean,
            type: DeliveryType.toTable,
            canChooseSeat: boolean,
            isChangeTableEnabled: boolean,
            description: LocalizedString
        },
        [DeliveryType.toAddress]:{
            isEnabled: boolean,
            type: DeliveryType.toAddress,
            deliveryConditions: DeliveryConditions,
            description: LocalizedString
        },
        [DeliveryType.takeaway]:{
            isEnabled: boolean,
            type: DeliveryType.takeaway,
            description: LocalizedString
        },
        [DeliveryType.takeawayToTime]:{
            isEnabled: boolean,
            type: DeliveryType.takeawayToTime,
            description: LocalizedString,
            isDateRequired: boolean,
        },
        [DeliveryType.toVehicle]:{
            isEnabled: boolean,
            type: DeliveryType.toVehicle,
            description: LocalizedString
        },
        [DeliveryType.insideTheRestaurant]:{
            isEnabled: boolean,
            type: DeliveryType.insideTheRestaurant,
            description: LocalizedString
        }
    },
    paymentSettings:{
        [PaymentProviderType.cloudpayments]: ICloudPaymentsPaymentSettings,
        [PaymentProviderType.sbpTochka]: ISBPTochkaPaymentSettings,
        [PaymentProviderType.offline]: IOfflinePaymentSettings,
        [PaymentProviderType.toBankCard]: IToBankCardPaymentSettings,
        [PaymentProviderType.companyInvoice]: ICompanyInvoiceSettings
    }
    photos: MenuPhotos;
    themeSettings: ThemeSettings,
    isOrderCreationEnabled: boolean;
    isCartEnabled: boolean;
    availableLanguages: MenuAvailableLanguages;
    isLoyaltyProgramEnabled: boolean;
    infoMessages: MenuInfoMessage[];
}

export interface MenuInfoMessageMediaItem {
    url: string;
}

export interface MenuInfoMessage {
    isEnabled: boolean,
    title: { [key: string]: string };
    description: { [key: string]: string };
    callToAction: { [key: string]: string };
    mediaItems: MenuInfoMessageMediaItem[];
}

export interface MenuAvailableLanguages {
    zh: MenuAvailableLanguageSettings;
    en: MenuAvailableLanguageSettings;
    it: MenuAvailableLanguageSettings;
    ru: MenuAvailableLanguageSettings;
}

export interface MenuAvailableLanguageSettings {
    isEnabled: boolean;
}

export interface Menu {
    data: MenuData;
    id: number;
    organizationBranchId: number;
    docs: {
        menuPublicOfferUrl: string | null
    },
    type: MenuType;
}


export interface MenuInfoPublic{
    id: number,
    organizationBranchId: number,
    data: MenuData,
    type: MenuType
}


export interface MenuCategoryData {
    name: { [key: string]: string };
    sortOrder: number;
    categoryCookingTime: CookingTime;
}

export interface CookingTime {
    fromTime: number | null,
    toTime: number | null
}

export interface MenuCategory {
    data: MenuCategoryData;
    id: number;
}

export interface MenuItemModifierDescriptor {
    menuItemModifierSetId: number;
    sortOrder: number;
}
export type BadgeFillKind = 'Solid' | 'Gradient';

// Где плашка рисуется на карточке: поверх фото или строкой под названием. У позиции без фото
// первые уходят в ту же строку — фото, на котором их можно показать, там нет.
export type BadgePlacement = 'OverPhoto' | 'Inline';

export interface BadgeFill {
    kind: BadgeFillKind;
    colorFrom: string;
    // Второй цвет и угол есть только у градиента.
    colorTo: string | null;
    angleDeg: number | null;
}

// Бейдж из справочника заведения: оформление приходит с бэка, у позиции лежат только id.
export interface ItemBadge {
    id: number;
    title: LocalizedString;
    fill: BadgeFill;
    textColor: string;
    placement: BadgePlacement;
}

export interface MenuItemData {
    // Порядок списка — порядок плашек на карточке; сами бейджи лежат каталогом в PublicMenuRest.
    badgeIds: number[];
    description: LocalizedString
    isInStopList: boolean;
    menuCategoryId: number;
    menuItemModifierSets: MenuItemModifierDescriptor[];
    name: LocalizedString,
    sellPrice: PriceInCurrency;
    oldPrice?: PriceInCurrency;
    cookingTimeFromCategory: boolean;
    itemCookingTime: CookingTime;
    media: MediaItem[];
    caloriesSettings: MenuItemCaloriesSettings;
    weightSettings: MenuItemWeightSettings;
    arCodeLink: string | null;
    supplierLogoUrl: string | null;
}
export interface MediaItem {
    preview: string;
    previewHighRes: string;
    regular: string;
    regularHighRes: string;
    source: string;
    // У gif и видео нарезок нет: preview/regular пустые, показывается source.
    kind: MediaKind;
}


export enum MediaType {
    source = "source",
    preview = "preview",
    regular = "regular",
}

export enum MediaKind {
    image = "image",
    gif = "gif",
    video = "video",
}

export interface MenuItem {
    data: MenuItemData;
    id: number;
}


export interface MenuItemModifierData {
    name: { [key: string]: string };
    sellPrice: PriceInCurrency;
    isInStopList: boolean
}

export interface MenuItemModifier {
    data: MenuItemModifierData;
    id: string
}

export interface MenuItemModifierSetData {
    modifiers: MenuItemModifier[];
    name: { [key: string]: string };
    type: ModifiersSetType;
}

export interface MenuItemModifierSetChooseOneData extends MenuItemModifierSetData {
    type: ModifiersSetType.ChooseOne
    isRequired: boolean
}

export interface MenuItemModifierSetChooseManyData extends MenuItemModifierSetData {
    type: ModifiersSetType.ChooseMany,
    maxCountTotalChosen: number,
    minCountTotalChosen: number
}


export interface MenuItemModifierSet {
    data: MenuItemModifierSetChooseOneData | MenuItemModifierSetChooseManyData;
    id: number;
}


export enum ModifiersSetType{
    ChooseMany = 'ChooseMany',
    ChooseOne = 'ChooseOne'
}


export interface TableSeat {
    publicId: string;
}

export interface TableData {
    publicId: number,
    title: {
        [s: string]: string
    },
    seats: TableSeat[];
}

export interface Table {
    id: number,
    data: TableData;
}

export interface MenuWithQuantitiesPublic extends Menu {
    docs: OrganizationBranchDocs;
}

export interface OrganizationBranchDocs {
    menuPublicOfferUrl: string | null;
}


export interface MenuItemCaloriesSettings {
    calories: number | null;
    carbohydrates: number | null;
    fats: number | null;
    proteins: number | null;
}

export interface MenuItemWeightSettings {
    measurement: string | null;
    value: string | null;
}


